'use client';

import React from 'react';

import { animated, useSpring } from '@react-spring/web';

import { Mood } from '../_data/data';

interface BreathingGameMoodCardProps {
  mood: Mood;
  onClick: (mood: Mood) => void;
}

export function BreathingGameMoodCard({ mood, onClick }: BreathingGameMoodCardProps) {
  const [svgStyles, svgApi] = useSpring(() => ({
    transform: `scale(1.125) translate(0, -5%)`,
    opacity: 0,
  }));

  React.useEffect(() => {
    const ms = 100 * Math.floor(Math.random() * (5 - 1 + 1) + 1);
    svgApi.start({ opacity: 1, transform: `scale(1) translate(0px, 0px)`, delay: ms });
  }, [svgApi]);

  return (
    <button className='flex flex-col items-center gap-y-2 text-sm' onClick={() => onClick(mood)}>
      <animated.svg
        className='size-20 cursor-pointer sm:size-24'
        fill='none'
        focusable='false'
        onMouseEnter={() => {
          svgApi.start({ transform: `scale(1.125) translate(0px, 0px)` });
        }}
        onMouseLeave={() => {
          svgApi.start({ transform: `scale(1) translate(0px, 0px)` });
        }}
        role='img'
        style={{
          transformOrigin: '50% 50%',
          ...svgStyles,
        }}
        xmlns='http://www.w3.org/2000/svg'
      >
        <use xlinkHref={`#${mood.id}`} />
      </animated.svg>
      {mood.name}
    </button>
  );
}
